module.exports = __webpack_public_path__ + "img/back-redirect-sm.caca08c3.webp";